export function formatPhone(phone: PhoneType) {
    return `(${phone.number.substring(0, 3)}) ${phone.number.substring(
        3,
        6
    )}-${phone.number.substring(6)}`;
}
